<template>
<transition :name="transition">
  <div
    :class="[`${prefixCls}-box`, colorClass]"
    ref="popper"
    :style="positionStyle"
    :data-position="position"
    :data-arrow="arrow"
    @mouseenter="$emit('mouseenter', $event)"
    @mouseleave="$emit('mouseleave', $event)"
    v-if="visible && !disabled"
  >
    <div :class="`${prefixCls}-section`">
      <div :class="`${prefixCls}-arrow`"></div>
      <div :class="`${prefixCls}-inner`">
        <slot name="content">
          <p :class="`${prefixCls}-label`" v-for="(item, index) in tipsLabel" :key="index" v-html="item"></p>
        </slot>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import VueTypes from 'vue-types'
import helper from '../../utils/helper'

import props from './props'

const prefixCls = 'gkui-popup'

export default {
  name: 'gk-popup-box',
  components: {
  },
  props: Object.assign({
    transition: VueTypes.string.def('scale-show'),
    visible: VueTypes.bool.def(true),
    reference: VueTypes.any,
    zIndex: VueTypes.number.def(1),
    /**
     * 出现位置的偏移量
     * @type Object
     */
    offset: VueTypes.object
  }, props),
  data () {
    return {
      positionStyle: {}
    }
  },
  computed: {
    prefixCls () {
      return prefixCls
    },
    tipsLabel () {
      return Array.isArray(this.label) ? this.label : [this.label]
    },
    colorClass () {
      return `${this.prefixCls}-color-${this.color}`
    }
  },
  watch: {
    visible (show) {
      show && this.setPosition()
    }
  },
  created () {
  },
  mounted () {
    this.visible && this.setPosition()
  },
  /**
   * 在编程调用时会使用 $mount 绑定到新建的 dom，所以销毁时手动删除 dom
   */
  beforeDestroy () {
    this.$el.remove()
  },
  methods: {
    setPosition () {
      if (this.disabled) {
        return
      }

      this.$nextTick(() => {
        const position = helper.position(this.reference, this.$el, {
          left: this.offset.left,
          top: this.offset.top,
          position: this.position,
          isInner: this.inner
        })

        this.positionStyle = {
          left: `${position.left}px`,
          top: `${position.top}px`,
          zIndex: this.zIndex
          // ,
          // width: `${position.width + position.width % 2}px`,
          // height: `${position.height + position.height % 2}px`
        }
      })
    }
  }
}
</script>
